module.exports = new __parcel__URL__("artifact_0009.8ea20456.png").toString();